import axios from "axios";
import { trackPromise } from "react-promise-tracker";
import Toast from "../components/Toast";

// eslint-disable-next-line no-undef
const route = process.env.REACT_APP_URL_BACKEND;
//esto no es muy feliz TODO MEJORAR
const PERMISSION_MESSAGE = 'no tiene permisos para realizar esta acción';

axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            const token = localStorage.getItem('paneltoken'); // Obtener el valor del token

            if (error.response.data.message !== PERMISSION_MESSAGE) {
                localStorage.clear();
                Toast.error("No se encuentra autorizado para realizar la acción, por favor vuelva a loguearse");
                window.location.reload();
            } else {
                Toast.error("No tiene los permisos para realizar la siguiente acción");
            }
        } else if (error.response && error.response.status === 403) {
            Toast.error(error.response.data.message);
        } else if (error.response && error.response.status === 400) {
            const { message } = error.response.data.error;
            // Verificar si el mensaje no es "Clave incorrecta" o "No existe el usuario ingresado"
            if (message !== 'Clave incorrecta!' && message !== 'No existe el usuario ingresado!') {
                //Toast.error("Ha ocurrido un error en el backend, por favor comunicarse con soporte");
            }
        } else if (error.response && error.response.status === 404) {
            Toast.error(error.response.data.message);
        } else if (error.response && error.response.status === 440) {
            Toast.warning("IMPORTANTE: Falta configurar datos de la empresa");
            return {
                statusText: "OK",
                data: null
            };
        } else if (error.response && error.response.status === 500) {
            Toast.error("Error interno en el servidor, por favor comunicarse con soporte");
        } else if (error) {
            Toast.error("Ha ocurrido un error en la aplicación, por favor comunicarse con soporte");
        } else if (error.response) {
            Toast.error("Ha ocurrido un error en la aplicación, por favor comunicarse con soporte");
        }
        return Promise.reject(error);
    }
);

export const getDataPublic = async (url, element = "") => {
    let res = await trackPromise(axios.get(`${route}${url}${element}`));
    if (res.status=== 200) {
        return res?.data;
    }
};


export const getData = async (url, element = "") => {
    let res = await trackPromise(axios.get(`${route}${url}${element}`, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("paneltoken")}`,
        }
    }));
    if (res.status === 200) {
        return (res.data);
    }
};

export const getDataWithNoTracking = async (url, element = "") => {
    let res = await axios.get(`${route}${url}${element}`, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("paneltoken")}`
        }
    });
    if (res.status === 200) {
        return (res.data);
    }
};

export const putData = async (url, body) => {
    let res = await trackPromise(axios.put(`${route}${url}`, body, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("paneltoken")}`
        }
    }));
    if (res.statusText === "OK") {
        Toast.success("El registro fue actualizado correctamente");
        return res.data;
    }
};

export const postData = async (url, body, hideToast) => {
    const token = localStorage.getItem("paneltoken");
    let config = {};
    if (token) {
        config.headers = {
            'Authorization': `Bearer ${token}`
        };
    }
    try {
        // Realiza la solicitud POST
        let res = await trackPromise(axios.post(`${route}${url}`, body, config));
        if (res.status === 201) {
            if (!hideToast) {
                Toast.success("El registro fue creado correctamente");
            }
            return res; // Respuesta exitosa
        }
        return res; // Respuesta para otros códigos
    } catch (error) {
        // Captura el error y extrae el mensaje
        if (error.response) {
            const errorMessage = error.response.data.message || "Error desconocido";
            // Muestra el mensaje de error en un Toast
            if (!hideToast) {
                Toast.error(`${errorMessage}`);
            }
            // Retorna el mensaje de error al llamador
            return { error: true, message: errorMessage };
        } else {
            // Para errores sin respuesta del servidor
            const genericError = "Ha ocurrido un error inesperado, por favor comuníquese con soporte.";
            if (!hideToast) {
                Toast.error(genericError);
            }
            return { error: true, message: genericError };
        }
    }
};

export const deleteData = async (url) => {
    let res = await trackPromise(axios.delete(`${route}${url}`, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("paneltoken")}`
        }
    }));
    if (res.status === 204) {
        Toast.success("El registro fue eliminado correctamente");
        return res;
    } else {
        console.error(res);
        return res;
    }
};

export const patchData = async (url, body, hideToast) => {
    let res = await trackPromise(axios.patch(`${route}${url}`, body, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("paneltoken")}`
        }
    }));
    if (res.status === 200) {
        if (!hideToast)
            Toast.success("El registro fue actualizado correctamente");
        return res;
    } else {
        console.error(res);
        return res;
    }
};
